"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var AudioCard = _base.default.makeDefaultCardType('audio', 'Audio', 'audio', true);

var _default = AudioCard;
exports.default = _default;